import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("svg", {
  width: "22",
  height: "22",
  viewBox: "0 0 22 22",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M14.9531 10.3125H7.04688C6.95234 10.3125 6.875 10.3898 6.875 10.4844V11.5156C6.875 11.6102 6.95234 11.6875 7.04688 11.6875H14.9531C15.0477 11.6875 15.125 11.6102 15.125 11.5156V10.4844C15.125 10.3898 15.0477 10.3125 14.9531 10.3125Z",
    fill: "black"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M11 1.375C5.68477 1.375 1.375 5.68477 1.375 11C1.375 16.3152 5.68477 20.625 11 20.625C16.3152 20.625 20.625 16.3152 20.625 11C20.625 5.68477 16.3152 1.375 11 1.375ZM11 18.9922C6.58711 18.9922 3.00781 15.4129 3.00781 11C3.00781 6.58711 6.58711 3.00781 11 3.00781C15.4129 3.00781 18.9922 6.58711 18.9922 11C18.9922 15.4129 15.4129 18.9922 11 18.9922Z",
    fill: "black"
  })
], -1)
const _hoisted_2 = [
  _hoisted_1
]




export default {
  __name: 'DeleteItemButton',
  emits: ['deleteItem'],
  setup(__props, { emit }) {



return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("button", {
    class: "Button--no-style w-[48px] h-[48px] flex items-center justify-center shrink-0 bg-white md:ml-5 rounded-md",
    onClick: _cache[0] || (_cache[0] = $event => (emit('deleteItem')))
  }, _hoisted_2))
}
}

}